<template>
  <main class="contact columns is-desktop">
    <div class="text-contact column is-three-fifths-desktop">
      <h2>CONTÁCTANOS</h2>
      <p>
        Déjanos tus datos y en menos de 24 horas nos pondremos en contacto para
        resolver tus consultas
      </p>
      <div class="info columns is-desktop">
        <div class="info__text column is-two-fifths-desktop is-hidden-touch">
          <div class="info_line">
            <img src="../assets/images/correo.png" alt />
            <p>contacto@contafacil.pe</p>
          </div>
          <div class="info_line">
            <img src="../assets/images/ubicacion.png" alt />
            <p>Ca Andres Reyes 338 San isidro, Lima, Peru</p>
          </div>
          <div class="info_line">
            <img src="../assets/images/telefono.png" alt />
            <p>
              <a
                href="https://wa.me/51972250227?text=Buenos días, quisiera información del sistema de facturación ContaFácil."
                target="_blank"
                rel="noopenner noreferer"
                >(51) 972 250 227</a
              >
            </p>
          </div>
        </div>
        <iframe
          src="https://forms.monday.com/forms/embed/248deb0290af830f72f3682ded1fd9fc?r=use1"
          width="100%"
          height="920"
        ></iframe>
        <div
          class="info__text info__text--bottom column is-two-fifths-desktop is-hidden-desktop"
        >
          <div class="info_line">
            <img src="../assets/images/correo.png" alt />
            <p>contacto@contafacil.pe</p>
          </div>
          <div class="info_line">
            <img src="../assets/images/ubicacion.png" alt />
            <p>Ca Andres Reyes 338 San isidro, Lima, Peru</p>
          </div>
          <div class="info_line">
            <img src="../assets/images/telefono.png" alt />
            <p>
              <a
                href="https://wa.me/51972250227?text=Buenos días, quisiera información del sistema de facturación ContaFácil."
                target="_blank"
                rel="noopenner noreferer"
                >(51) 972 250 227</a
              >
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="visual column column-40 is-hidden-touch">
      &nbsp;
    </div>
  </main>
</template>

<script>
// @ is an alias to /src
export default {
  name: "Contactanos",
  data() {
    return {
      isSent: false
    };
  }
};
</script>
<style lang="scss" scoped>
@import "../assets/styles/general.scss";
.contact {
  flex-flow: row wrap;
  margin: 0rem 0;
  margin-bottom: 3em;
  @include laptop() {
    margin-bottom: 8em;
  }
  h2 {
    font-weight: normal;
    font-size: 1.2rem;
    font-family: "Geometos", sans-serif;
  }
  p {
    margin: 1em 0;
    font-size: 13px;
    line-height: 1.2;
    letter-spacing: 0.025em;
    padding: 0 2rem;
  }
  .text-contact {
    padding: 3em 0;
  }
  .visual {
    background-image: url("../assets/images/contactus-image.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }
  form {
    margin-bottom: 0;
  }
  .info {
    align-items: flex-start;
    padding: 0 1em;
    box-sizing: border-box;
    margin: 0;
    margin-top: 1em;
    position: relative;
    overflow: hidden;
  }
  .info__form {
    padding: 1rem;
    margin: 0px;
    box-sizing: border-box;
  }
  .field {
    width: 100%;
    // margin: auto;
    margin: 2em 0;
    &:first-of-type {
      margin-top: 0;
    }
    @include desktop-medium() {
      input,
      textarea {
        font-size: 1rem;
        &::placeholder {
          font-size: 1em;
        }
      }
    }
    @include desktop-large() {
      input,
      textarea {
        font-size: 1.4rem;
      }
    }
  }
  .field-submit {
    @include laptop() {
      display: flex;
      align-items: center;
    }
  }
  .info__text {
    box-sizing: border-box;
    @include laptop() {
      padding-left: 2em;
    }
    @include desktop() {
      padding-left: 2em;
    }
    @include desktop-medium() {
      padding-left: 4em;
    }
    @include desktop-large() {
      padding-left: 4em;
    }
    &--bottom {
      // position: absolute;
      padding-left: 3em;
      border-radius: 30px;
      transform: translate(20%, -10px);
      box-shadow: 0 0px 6px 2px rgba($color: #666666, $alpha: 0.4);
      .info_line {
        p {
          font-size: 14px;
        }
      }
      @include tablet() {
        transform: translate(40%, -10px);
      }
      @include laptop() {
        display: none;
        transform: translate(55%, -10px);
      }
    }
  }
  .info_line {
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-items: center;
    margin: 2em 0;
    img {
      width: 20px;
      margin-right: 10px;
    }
    p {
      font-size: 14px;
      margin: 1em 0;
    }
    @include laptop() {
      p {
        font-size: 0.8rem;
        text-align: start;
      }
    }
    @include desktop() {
      p {
        font-size: 1rem;
        text-align: start;
      }
    }
    @include desktop-medium() {
      p {
        font-size: 1rem;
        text-align: start;
      }
    }
    @include desktop-large() {
      p {
        font-size: 1.2rem;
        text-align: start;
      }
    }
  }
  @include laptop() {
    h2 {
      font-size: 1.8rem;
      margin: 2rem auto;
    }
    p {
      font-size: 1rem;
      margin: 1rem auto;
    }
  }
  @include desktop() {
    h2 {
      font-size: 1.8rem;
      margin: 2rem auto;
    }
    p {
      font-size: 1rem;
      margin: 1rem auto;
    }
  }
  @include desktop-medium() {
    h2 {
      font-size: 2.5rem;
      margin: 2rem auto;
    }
    p {
      font-size: 1.2rem;
      margin: 1rem auto;
    }
  }
  @include desktop-large() {
    h2 {
      font-size: 2.8rem;
      margin: 2rem auto;
    }
    p {
      font-size: 1.4rem;
      margin: 1rem auto;
    }
  }
}

.text-confirmation {
  font-size: 16px;
  width: 100%;
  margin: 0;
  margin-right: 2rem;
  @include laptop() {
    font-size: 12px;
  }
  @include desktop() {
    font-size: 1rem;
  }
}
.input-submit {
  width: fit-content;
  padding: 0 1.5em;
  border-radius: 10px;
  font-family: "Quicksand", Avenir, Helvetica, Arial, sans-serif !important;
  @include tablet() {
    // max-width: 200px;
    // margin: ;
  }
  @include laptop() {
    width: fit-content;
    font-size: 12px;
    margin-left: auto;
  }
  @include desktop() {
    width: fit-content;
    font-size: 1rem;
    margin-left: auto;
  }
}
</style>
